howspace.components.autosize = (() => {
    'use strict';

    const widthHelper = document.createElement('span');
    widthHelper.style.whiteSpace = 'pre-wrap';
    widthHelper.style.display = 'none';
    document.body.appendChild(widthHelper);

    const handleInputInput = (e) => {
        autosizeWidth(e.target);
    };

    const handleInputPaste = (e) => {
        requestAnimationFrame(() => {
            autosizeWidth(e.target);
        });
    };

    const autosizeWidth = (input, computedStyle = null) => {
        if (computedStyle === null) {
            computedStyle = getComputedStyle(input);
        }
        const borderWidth = parseFloat(computedStyle.borderTopWidth) + parseFloat(computedStyle.borderBottomWidth);
        const paddingLeft = parseFloat(computedStyle.paddingLeft.replace('px', ''));
        const paddingRight = parseFloat(computedStyle.paddingRight.replace('px', ''));
        const autoSizeMargin = computedStyle.getPropertyValue('--autosize-margin') || '0px';
        widthHelper.style.font = computedStyle.font;
        widthHelper.style.paddingRight = autoSizeMargin;
        // A floating label forces the placeholder to a single blank, so fall back to the
        // resting label text — it occupies the same space a placeholder used to.
        widthHelper.innerText = input.value || (input.getAttribute('placeholder') || '').trim()
            || input.closest('.howspace-form-label-floating')?.querySelector('.howspace-form-label-text')?.innerText
            || '';
        widthHelper.style.display = 'inline-block';
        input.style.width = borderWidth + paddingLeft + paddingRight + widthHelper.scrollWidth + 'px';
        widthHelper.innerText = '';
        widthHelper.style.display = 'none';
    };

    const handleTextareaInput = (e) => {
        autosizeTextarea(e.target);
    };

    const handleTextareaPaste = (e) => {
        requestAnimationFrame(() => {
            autosizeTextarea(e.target);
        });
    };

    const autosizeTextarea = (textarea) => {
        if (textarea.scrollHeight <= 0) {
            return;
        }
        const computedStyle = getComputedStyle(textarea);
        const borderWidth = parseFloat(computedStyle.borderTopWidth) + parseFloat(computedStyle.borderBottomWidth);
        if (textarea.classList.contains('autosize-width')) {
            autosizeWidth(textarea, computedStyle);
        }
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + borderWidth + 'px';
    };

    return {
        init : (elem) => {
            elem.findIncludingSelf('textarea.autosize:not(.autosize-initialized)').each((i, textarea) => {
                textarea.classList.add('autosize-initialized');
                textarea.addEventListener('input', handleTextareaInput);
                textarea.addEventListener('paste', handleTextareaPaste);
                autosizeTextarea(textarea);
            });

            elem.findIncludingSelf('input.autosize:not(.autosize-initialized)').each((i, input) => {
                input.classList.add('autosize-initialized');
                input.addEventListener('input', handleInputInput);
                input.addEventListener('paste', handleInputPaste);
                autosizeWidth(input);
            });
        },

        update : (elem) => {
            elem.findIncludingSelf('textarea.autosize.autosize-initialized').each((i, textarea) => {
                autosizeTextarea(textarea);
            });

            elem.findIncludingSelf('input.autosize.autosize-initialized').each((i, input) => {
                autosizeWidth(input);
            });
        },

        destroy : (elem) => {
            elem.findIncludingSelf('textarea.autosize.autosize-initialized').each((i, textarea) => {
                textarea.classList.remove('autosize-initialized');
                textarea.setAttribute('resize', '');
                textarea.removeEventListener('input', handleTextareaInput);
                textarea.removeEventListener('paste', handleTextareaPaste);
            });

            elem.findIncludingSelf('input.autosize.autosize-initialized').each((_i, input) => {
                input.classList.remove('autosize-initialized');
                input.removeEventListener('input', autosizeWidth);
            });
        }
    };

})();
